<template>
  <div class="main-list">
    <div class="header">
      <h3>Clientes</h3>
      <div>
        <el-dropdown
          class="dropdown-list"
          trigger="click">
          <span class="el-dropdown-link">
            <i class="icon-sliders"/>Filtros
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(filter, index) in filtersFor"
              :key="index">
              <el-radio
                v-model="filtersValue"
                :label="filter.value"
                @change="onChangeRadio">
                {{ filter.name }}
              </el-radio>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button
          v-if="profile.role !== 'gerente_dealer' && profile.role !== 'superadmin'"
          type="primary"
          circle
          class="btn-add"
          style="padding: 7px"
          @click="showClientPanel">
          <i class="icon-plus"/>
        </el-button>
      </div>
    </div>
    <el-row>
      <el-col>
        <el-input
          v-debounce:1s="defaultSearchFunction"
          v-model="searchVal"
          class="input-round"
          placeholder="Escribe tu busqueda"
          suffix-icon="icon-search"/>
      </el-col>
    </el-row>
    <div
      v-if="customersItems.length !== 0"
      class="content-list-item">
      <el-row>
        <el-col>
          <div
            v-for="(clientItem, index) in customersItems"
            :key="clientItem.id"
            :style="{ animationDelay: (index * 50) + 'ms' }"
            class="item-client"
            @click="currentItem(clientItem.id)">
            <list-item
              :show-edit="profile.role !== 'gerente_dealer'"
              :item="clientItem"
              :is-active="$route.params.id == clientItem.id || (!$route.params.id && index == 0)"
              :is-favorit="false"
              @click="clickItemClient"
              @assignBranch="onAssignBranch"
              @assign="onAssign"
              @reassign="onReassign"
              @edit="onEdit"
              @fuse="onFuse"
              @delete="onDelete"/>
          </div>
          <div
            v-if="isLoading"
            style="display: flex; flex-align: center; justify-content: center;">
            <i
              class="el-icon-loading"
              style="color: #000; font-size: 20px;"/>
          </div>
        </el-col>
      </el-row>
    </div>
    <div v-if="customersItems.length <= 0">
      <not-found @addElement="createNewClient"/>
    </div>
  </div>
</template>
<script>
import ListItem from '@/components/_shared/list-item'
import NotFound from '@/components/_shared/not-found'
export default {
  name: 'CustomersList',
  components: {
    ListItem,
    NotFound
  },
  props: {
    activeClientId: {
      type: Number,
      default: null
    },
    customersItems: {
      type: Array,
      default: null
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      customersList: [],
      filtersFor: [
        {
          name: 'Por Compañia',
          value: 'company'
        },
        {
          name: 'Por Nombre',
          value: 'name'
        }
      ],
      filtersValue: 'name',
      searchVal: ''
    }
  },
  computed: {
    profile () {
      return this.$store.getters['profile/me']
    },
    customers () {
      return this.$store.getters['customers/items']
    }
  },
  mounted () {
    if (this.$route.query.search) {
      this.searchVal = this.$route.query.search
    }
  },
  methods: {
    clickItemClient (val) {
      this.searchVal = ''
      this.$router.push({ name: 'customers-info', params: { id: val.id } })
    },
    onEdit (val) {
      this.$emit('onEdit', val)
    },
    onAssign (val) {
      this.$emit('onAssign', val)
    },
    onReassign (val) {
      this.$emit('onReassign', val)
    },
    onAssignBranch (val) {
      this.$emit('onAssignBranch', val)
    },
    onFuse (val) {
      this.$emit('onFuse', val)
    },
    onDelete (val) {
      this.$emit('onDelete', val)
    },
    showClientPanel () {
      this.$emit('onCreate')
      this.$store.dispatch('app/toggleClientPanel')
    },
    createNewClient () {
      this.$store.dispatch('app/toggleClientPanel')
    },
    defaultSearchFunction (val) {
      let _defaultQuery = {}
      _defaultQuery[`search`] = val
      this.executeFilter(_defaultQuery)
    },
    executeFilter (queryValue) {
      let query = Object.assign({}, this.$route.query)
      this.$router.replace({ query: { ...query, ...queryValue } })
    },
    currentItem (val) {
      for (let customer of this.customersList) {
        if (val === customer.id) {
          customer.isActive = true
        } else {
          customer.isActive = false
        }
      }
    },
    onChangeRadio (val) {
      let query = Object.assign({}, this.$route.query)
      this.$router.replace({ query: { ...query, typeSearch: val } })
    }
  }
}
</script>

<style lang="scss" scoped>
.main-list {
  height: calc(100% - 60px);
  padding: 15px;
  .header {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
    h3 {
      color: #707070;
      @include font-primary(21px, regular);
      margin: 0;
    }
    > div {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      .dropdown-list {
        margin-right: 30px;
        .el-dropdown-link {
          color: #3E3E3E;
          @include font-primary(13px, semibold);
          display: flex;
          flex-flow: row nowrap;
          align-items: center;
          cursor: pointer;
          i {
            margin-right: 10px;
            color: #707070;
            font-size: 18px;
          }
        }
      }
      .btn-add {
        box-shadow: 0 3px 6px rgba(#E7120E, 0.26);
        i {
          font-size: 23px;
        }
      }
    }
  }
  .content-list-item {
    margin: 15px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/customers/customers-list.vue